import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["createButton"])
  },
  watch: {
    createButton: function() {
      this.createAction();
    }
  }
};
